let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drdqO")).then(() => parcelRequire('3RKn1'));